import type { GeneralConfig } from '@shared/types/Config';

export const stewardConfig: GeneralConfig = {
    sortFieldMap: {},
};
